import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, {
  init,
  queryGoods,
  submit,
  queryMobilePackage,
  initPage,
  queryOperatorList,
  queryPostpaidBillRecord
} from './modules'
import Loading from 'components/Loading'
import { queryConfigItem } from 'store/siteConfig'

export default function(route) {
  const Mobile = Loadable({
    loader: () => import('./Mobile'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpMobileState: state.topUpMobileState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          queryGoods,
          submit,
          queryMobilePackage,
          initPage,
          queryOperatorList,
          queryPostpaidBillRecord,
          queryConfigItem
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/mobile`}
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Mobile {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
